module.exports = __webpack_public_path__ + "assets/img/9e33-gh.svg";